/**
 * 페이지 사이즈 상수 정의
 * 모든 논문 관련 미리보기, PDF 생성에서 사용
 */

export const PAGE_SIZES = {
  A4: {
    name: 'A4',
    width: 210,
    height: 297,
    unit: 'mm',
    // 픽셀 단위 (96 DPI 기준)
    widthPx: 794,
    heightPx: 1123,
    // jsPDF format
    format: 'a4',
  },
  A5: {
    name: 'A5',
    width: 148,
    height: 210,
    unit: 'mm',
    // 픽셀 단위 (96 DPI 기준)
    widthPx: 559,
    heightPx: 794,
    // jsPDF format
    format: 'a5',
  },
}

/**
 * 페이지 사이즈 코드로 설정 가져오기
 * @param {string} sizeCode - 'A4' 또는 'A5'
 * @returns {Object} 페이지 사이즈 설정
 */
export function getPageSize(sizeCode = 'A4') {
  const code = sizeCode?.toUpperCase() || 'A4'
  return PAGE_SIZES[code] || PAGE_SIZES.A4
}

/**
 * 페이지 사이즈 CSS 스타일 생성
 * @param {string} sizeCode - 'A4' 또는 'A5'
 * @returns {Object} CSS 스타일 객체
 */
export function getPageSizeStyle(sizeCode = 'A4') {
  const size = getPageSize(sizeCode)
  return {
    width: `${size.width}mm`,
    minHeight: `${size.height}mm`,
  }
}

/**
 * @page 규칙용 사이즈 문자열
 * @param {string} sizeCode - 'A4' 또는 'A5'
 * @returns {string} '@page { size: A4; }' 형태
 */
export function getPageAtRule(sizeCode = 'A4') {
  const size = getPageSize(sizeCode)
  return `@page { size: ${size.name}; margin: 0; }`
}

export default PAGE_SIZES
